/*
Contact Us Sections
 */
/* eslint-disable */

const contactUsSections = [
  {
    section: 'Chat',
    subText: 'Chat live with our agents for help with most issues and lower wait time.',
    icon: 'IconChat',
    recommended: true,
    adobeTag: 'card_chat',
    sideText: 'Quickest',
    showPhoneComponent: false,
    buttonContent: 'Start chat'
  },
];

export {
  contactUsSections,
};

